import {Component, Inject, OnDestroy, OnInit, PLATFORM_ID} from '@angular/core';
import {Subject, takeUntil} from 'rxjs';
import {ActivatedRoute, Router} from '@angular/router';
import {isPlatformBrowser} from '@angular/common';

@Component({
  selector: 'app-redirect',
  imports: [],
  templateUrl: './redirect.component.html',
  styleUrl: './redirect.component.scss'
})
export class RedirectComponent implements OnInit, OnDestroy {
  onDestroy$ = new Subject<boolean>();

  constructor(@Inject(PLATFORM_ID) private platformId: Object,
              private route: ActivatedRoute,
              private router: Router) {
  }

  ngOnInit() {
    this.route.data.pipe(takeUntil(this.onDestroy$)).subscribe(data => {
      const redirect = data['redirect'] || '/';

      // Redirecting only if the view generated is from a client instead from a server because
      // when pre-render generation happens, it will apply the next page's metadata on the current
      // redirect pre-rendered page.
      if (isPlatformBrowser(this.platformId)) {
        setTimeout(() => this.router.navigateByUrl(redirect).finally(), 0)
      }
    });
  }

  ngOnDestroy() {
    this.onDestroy$.next(true);
    this.onDestroy$.complete();
  }

}
